export default __webpack_public_path__ + "static/media/DInsurer.c82b850c.png";